<template>
  <!-- Resume Info -->
  <div class="modal fade" id="resumeInfoModal" tabindex="-1"
       aria-labelledby="updateDisciplineDisciplineLabel"
       aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="updateDisciplineDisciplineLabel">Резюме</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <div class="col-md-12 mt-4 px-3" v-if="personalData.firstname">
            <div>
              <h4>{{ getFio(personalData) }},
                дата рождения {{dateFormatter(personalData.birth_date) }}</h4>
              <div>{{ personalData.birth_place }}</div>
            </div>


            <div class="mt-4" v-if="educationData.length">
              <h5>Образование</h5>
              <div class="mt-3"
                   v-for="(edu, index) in educationData"
                   :key="index">
                <div class="row">
                  <div class="col-lg-2 col-md-4 col-sm-6">{{edu.start_year}} -
                    {{edu.end_year}}
                  </div>
                  <div class="col-lg-9 col-md-8 col-sm-6">
                    <div>
                      <strong>{{edu.name}}, {{edu.address}}</strong>
                    </div>
                    <div>
                      {{edu.specialization}}
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="mt-4" v-if="jobData.length">
              <h5>Опыт работы</h5>
              <div class="mt-3"
                   v-for="(job, index) in jobData"
                   :key="index">
                <div class="row">
                  <div class="col-lg-2 col-md-4 col-sm-6">{{dateFormatter(job.start_year)}} -
                    {{ dateFormatter(job.end_year) || ''}}
                  </div>
                  <div class="col-lg-9 col-md-8 col-sm-6">
                    <div>
                      <strong>{{job.name}}, {{job.address}}</strong>
                    </div>
                    <div v-if="job.title">
                      {{job.title}}
                    </div>
                  </div>
                </div>

              </div>
            </div>


            <div class="mt-5">
              <h5>Связь</h5>
              <div class="mt-3">
                <div class="row">
                  <div class="col-lg-2 col-md-4 col-sm-6">Телефон</div>
                  <div class="col-lg-9 col-md-8 col-sm-6">{{ personalData.phone_number }}
                  </div>
                </div>


              </div>
            </div>

          </div>


        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            Закрыть
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- End Resume Info -->
</template>

<script>

import {mapGetters, mapActions, mapMutations, mapState} from "vuex";


export default {
  name: "ResumeInfoModal",
  components: {

  },

  data() {
    return {

    }
  },
  computed: {

    ...mapState('userinfo', ['personalData', 'educationData', 'jobData', 'langData']),
    ...mapState('vacancy', ['resumeInfoModalUserId']),
  },

  methods: {
    ...mapActions('userinfo', ['GET_USER_PERSONAL_DATA', 'GET_USER_EDUCATION_DATA', 'GET_USER_JOB_DATA', 'GET_USER_LANG_DATA']),

    getFio(user) {
      return `${user.lastname || ''} ${user.firstname || ''} ${user.middlename || ''}`
    },
    dateFormatter(value) {
      if (!value) {
        return ''
      }
      const locale = 'ru-RU'
      const options = {}

      options.day = '2-digit'
      options.month = 'long'
      options.year = 'numeric'

      return new Intl.DateTimeFormat(locale, options).format(new Date(value))
    },


  },
  async mounted() {
    await this.GET_USER_PERSONAL_DATA(this.resumeInfoModalUserId)
    await this.GET_USER_EDUCATION_DATA(this.resumeInfoModalUserId)
    await this.GET_USER_JOB_DATA(this.resumeInfoModalUserId)
    await this.GET_USER_LANG_DATA(this.resumeInfoModalUserId)


  }
}
</script>

<style scoped>

</style>